<app-calculators></app-calculators>
<app-templates-documents></app-templates-documents>
<app-card-links></app-card-links>
<app-support></app-support>
